var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Box, Button, Grid, MenuItem, Popover, Select, Stack, Typography, useTheme } from "@mui/material";
import LinkIcon from '@mui/icons-material/Link';
import HtmlIcon from '@mui/icons-material/Html';
import ViewQuiltIcon from '@mui/icons-material/ViewQuilt';
import { ContentSourceType } from "../models/content/content.model";
import { useOrganization } from "../state/auth.reducer";
import { getIconForLanguage, getNameForLanguage } from "../utils/translations.util";
import { useSupportedLanguages } from "../utils/useSupportedLanguages";
import ContentEditor from "./ContentEditor.component";
import TextField from "@mui/material/TextField";
var CLocalizedEditor = function (_a) {
    var value = _a.value, onChange = _a.onChange, isDirty = _a.isDirty;
    var theme = useTheme();
    var styles = {
        input: {
            width: '100%',
            border: '1px solid #D8D6DE',
            marginTop: theme.spacing(2),
            borderRadius: 6
        },
        languageIconHolder: {
            width: 35,
            height: 30,
            borderRadius: 4,
            boxSizing: 'border-box'
        },
        languageIcon: {
            width: 25,
            height: 25,
            objectFit: 'contain',
            cursor: 'pointer',
            transitions: 'all 0.5s'
        },
        languageIconSelected: {
            background: "".concat(theme.palette.primary.main, "4C"),
            border: "1px solid ".concat(theme.palette.primary.main)
        },
        warningTitle: {
            marginBottom: theme.spacing(1)
        },
        warningLanguage: {
            minWidth: 80
        }
    };
    var _b = useTranslation(), i18n = _b.i18n, t = _b.t;
    var _c = useState(i18n.language), language = _c[0], setLanguage = _c[1];
    var hasSourceForLanguage = value === null || value === void 0 ? void 0 : value[language];
    var currentValueLocalized = (value === null || value === void 0 ? void 0 : value[language]) || {};
    var _d = React.useState(null), anchorEl = _d[0], setAnchorEl = _d[1];
    var _e = useState(true), languageChanging = _e[0], setLanguageChanging = _e[1];
    var _f = useState(false), editing = _f[0], setEditing = _f[1];
    var _g = useState(false), pickTemplateDialogOpen = _g[0], setPickTemplateDialogOpen = _g[1];
    useEffect(function () {
        if (!isDirty) {
            setEditing(false);
        }
    }, [isDirty]);
    var updateValue = function (newValue) {
        var _a;
        if (!newValue)
            return;
        setEditing(true);
        onChange === null || onChange === void 0 ? void 0 : onChange(__assign(__assign({}, value), (_a = {}, _a[language] = newValue, _a)));
    };
    var organization = useOrganization();
    var availableLanguages = useSupportedLanguages();
    var languagesUI = (_jsx(Select, __assign({ value: language || '', sx: { minHeight: '35px', borderRadius: '8px' }, variant: "outlined", onChange: function (e) { return setLanguage(e.target.value); }, size: 'small' }, { children: availableLanguages.map(function (language) { return (_jsx(MenuItem, __assign({ value: language }, { children: getNameForLanguage(language) }), language)); }) })));
    var sourceUI = (_jsxs(Grid, __assign({ container: true, spacing: 1, alignItems: 'center' }, { children: [_jsx(Grid, __assign({ item: true }, { children: _jsx(Typography, { children: t('Source') }) })), _jsx(Grid, __assign({ item: true }, { children: _jsx(Button, __assign({ variant: (!(currentValueLocalized === null || currentValueLocalized === void 0 ? void 0 : currentValueLocalized.sourceType) || currentValueLocalized.sourceType === ContentSourceType.UNLAYER) ? 'contained' : 'outlined', onClick: function () { return updateValue(__assign(__assign({}, currentValueLocalized), { sourceType: ContentSourceType.UNLAYER })); } }, { children: _jsx(ViewQuiltIcon, {}) })) })), _jsx(Grid, __assign({ item: true }, { children: _jsx(Button, __assign({ variant: (currentValueLocalized === null || currentValueLocalized === void 0 ? void 0 : currentValueLocalized.sourceType) === ContentSourceType.CUSTOM_HTML ? 'contained' : 'outlined', onClick: function () { return updateValue(__assign(__assign({}, currentValueLocalized), { sourceType: ContentSourceType.CUSTOM_HTML })); } }, { children: _jsx(HtmlIcon, {}) })) })), _jsx(Grid, __assign({ item: true }, { children: _jsx(Button, __assign({ variant: (currentValueLocalized === null || currentValueLocalized === void 0 ? void 0 : currentValueLocalized.sourceType) === ContentSourceType.URL ? 'contained' : 'outlined', onClick: function () { return updateValue(__assign(__assign({}, currentValueLocalized), { sourceType: ContentSourceType.URL })); } }, { children: _jsx(LinkIcon, {}) })) })), _jsx(Grid, __assign({ item: true }, { children: _jsx(Button, __assign({ "aria-describedby": !!anchorEl ? 'content-language-picker' : undefined, onClick: function (event) {
                        setAnchorEl(event.currentTarget);
                    } }, { children: t('Copy from...') })) })), _jsx(Popover, __assign({ id: !!anchorEl ? 'content-language-picker' : undefined, open: !!anchorEl, anchorEl: anchorEl, onClose: function () {
                    setAnchorEl(null);
                }, anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'center',
                }, transformOrigin: {
                    vertical: 'top',
                    horizontal: 'center',
                } }, { children: availableLanguages.filter(function (lng) { return lng !== language; }).map(function (lng) { return (_jsxs(Box, __assign({ alignItems: 'center', paddingLeft: 2, paddingRight: 2, paddingTop: 1, paddingBottom: 1, sx: {
                        display: 'flex',
                        alignItems: 'center',
                        cursor: 'pointer'
                    }, onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                        var copyLangValue;
                        return __generator(this, function (_a) {
                            copyLangValue = value === null || value === void 0 ? void 0 : value[lng];
                            updateValue(__assign(__assign({}, currentValueLocalized), { sourceType: copyLangValue === null || copyLangValue === void 0 ? void 0 : copyLangValue.sourceType, url: copyLangValue === null || copyLangValue === void 0 ? void 0 : copyLangValue.url, htmlCode: copyLangValue === null || copyLangValue === void 0 ? void 0 : copyLangValue.htmlCode, content: copyLangValue === null || copyLangValue === void 0 ? void 0 : copyLangValue.content, generatedHtmlCode: copyLangValue === null || copyLangValue === void 0 ? void 0 : copyLangValue.generatedHtmlCode }));
                            setAnchorEl(null);
                            return [2 /*return*/];
                        });
                    }); } }, { children: [_jsx("img", { alt: lng, style: styles.languageIcon, src: getIconForLanguage(lng) }), _jsx(Typography, __assign({ sx: { ml: 1 } }, { children: getNameForLanguage(lng) }))] }), lng)); }) }))] })));
    useEffect(function () {
        setLanguageChanging(true);
    }, [language]);
    useEffect(function () {
        if (languageChanging) {
            setLanguageChanging(false);
        }
    }, [languageChanging]);
    return (_jsxs(Box, __assign({ flexDirection: 'column', width: '100%' }, { children: [_jsxs(Stack, __assign({ direction: 'row', alignItems: 'center', gap: 2, mb: 1 }, { children: [languagesUI, sourceUI] })), !anchorEl && !languageChanging && (!(currentValueLocalized === null || currentValueLocalized === void 0 ? void 0 : currentValueLocalized.sourceType) || (currentValueLocalized === null || currentValueLocalized === void 0 ? void 0 : currentValueLocalized.sourceType) === ContentSourceType.UNLAYER) &&
                _jsx(Box, __assign({ height: 'calc(100vh - 330px)' }, { children: _jsx(ContentEditor, { content: currentValueLocalized, onSaved: updateValue, displayMode: 'web' }) })), (currentValueLocalized === null || currentValueLocalized === void 0 ? void 0 : currentValueLocalized.sourceType) === ContentSourceType.CUSTOM_HTML &&
                _jsxs(Box, __assign({ width: '100%', 
                    // height={'calc(100vh - 280px)'}
                    display: 'flex' }, { children: [_jsx(TextField, { multiline: true, rows: Math.floor((window.innerHeight - 300) / 20), value: currentValueLocalized.htmlCode, onChange: function (e) {
                                updateValue(__assign(__assign({}, currentValueLocalized), { htmlCode: e.target.value }));
                            }, sx: {
                                flex: 1,
                                //height: 'calc(100vh - 280px)'
                            } }), _jsx(Box, { width: 20 }), _jsx(Box, __assign({ width: '100%', height: 'calc(100vh - 250px)', flexDirection: 'column', sx: {
                                flex: 1,
                                overflow: 'auto'
                            } }, { children: _jsx(Box, { dangerouslySetInnerHTML: {
                                    __html: currentValueLocalized.htmlCode || ''
                                } }) }))] })), (currentValueLocalized === null || currentValueLocalized === void 0 ? void 0 : currentValueLocalized.sourceType) === ContentSourceType.URL &&
                _jsxs(Box, __assign({ width: '100%', height: 'calc(100vh - 300px)', display: 'flex', flexDirection: 'column' }, { children: [_jsx(TextField, { placeholder: 'Url', value: currentValueLocalized.url, onChange: function (e) {
                                updateValue(__assign(__assign({}, currentValueLocalized), { url: e.target.value }));
                            } }), _jsx(Box, { height: 20 }), _jsx("iframe", { width: '100%', height: window.innerHeight - 300, style: {
                                flex: 1,
                            }, src: currentValueLocalized.url || '' })] }))] })));
};
export default CLocalizedEditor;
